import { Form, Text } from 'react-form';
import { AbconetApi } from '../General/AbconetApi';
import { isNullOrUndefined } from 'util';
import { emptyStringIfNull } from '../General/Helper'
var SiteSelector = require('../General/Selectors/SiteSelector').SiteSelector;
var EquipmentTypeSelector = require('../General/Selectors/EquipmentTypeSelector').EquipmentTypeSelector;
var EquipmentMakeModelSelector = require('../General/Selectors/EquipmentMakeModelSelector').EquipmentMakeModelSelector;
var NextServiceSiteSelector = require('../General/Selectors/NextServiceSiteSelector').NextServiceSiteSelector;

export class EquipmentEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaved: true,
            isSaving: false,
            submittedValues: this.props.initialState,
            errorMessage: ""
        }
    }

    renderHeader() {
        if (this.props.initialState.id <= 0) {
            return <div><i className="icon icon-order lead d-flex justify-content-center"></i><h4 className="text-center"><strong>Create Equipment</strong></h4></div>;
        }

        return <div><i className="icon icon-order lead d-flex justify-content-center"></i><h4 className="text-center"><strong>Edit Equipment</strong></h4></div> ;
    }

    setChange(data) {
        this.setState({
            isSaved: false,
            submittedValues: {
                equipmentType:
                {
                    id: data.values.equipmentType.id,
                    name: data.values.equipmentType.name
                }
            }
        });
    }

    submitEquipment(submittedValues) {
        if (isNullOrUndefined(submittedValues.name) || submittedValues.name === '') {
            alert('Please enter equipment name');

            return;
        }

        this.setState({ submittedValues, isSaving: true }, this.sendStateToServer);
    }

    sendStateToServer() {
        var self = this;        
        AbconetApi.post('/api/equipment/', this.state.submittedValues).then(response => {
            if (this.props.onCreateSite) {
                this.props.onCreateSite(response);
            }

            self.setState({ isSaved: true, errorMessage: "", isSaving: false });
            window.location.reload();
        })
            .catch((error) => {
                self.setState({
                    isSaved: true,
                    isSaving: false
                });
            });
    }

    getLabelColClassName() {
        if (this.props.miniMode) {
            return 'col-6';
        }

        return 'col-sm-2';
    }

    getValueColClassName() {
        if (this.props.miniMode) {
            return 'col-6';
        }

        return 'pl-0 col-sm-13';
    }

    renderFinishEditingButton() {
        if (this.props.initialState.id === 0) {
            return;
        }

        return <button onClick={this.finishEdit.bind(this)}  className="btn btn-outline-primary btn-lg">Back</button>;
    }

    finishEdit() {
        if (this.props.onFinishEdit) {
            this.props.onFinishEdit(this.state.submittedValues);
        }
    }

    renderCancelButton() {
        if (!this.props.initialState.canEdit && this.props.initialState.id !== 0) {
            return;
        }

        var btnText = 'Cancel';
        var btnClass = 'changes';


        return <button className={"btn btn-outline-primary " + btnClass} disabled={this.state.isSaving} onClick={this.handleCancel.bind(this)}>{btnText}</button>;
    }

    handleCancel(ev) {
        ev.preventDefault();
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    renderSaveButton() {

        if (!this.props.initialState.canEdit && this.props.initialState.id !== 0) {
            return;
        }


        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        if (!this.props.miniMode) {
            btnClass += ' float-right';
        }

        return <button className={"btn btn-lg btn-primary " + btnClass} disabled={this.state.isSaved || this.state.isSaving}>{btnText}</button>;
    }

    validateLength(e, length) {
        if (e.target.value.length > length) {
            e.target.value = e.target.value.slice(0, length)
        } else {
            e.target.value;
        }
    }

    render() {
        var cardClassName = "card-body text-dark";

        return (
            <div>
  

                <Form
                    onChange={this.setChange.bind(this)}
                    onSubmit={this.submitEquipment.bind(this)}
                    defaultValues={this.state.submittedValues}>
                    {formApi => {
                        this.formApi = formApi;
                        return (
                            <form autoComplete="off" onSubmit={formApi.submitForm} id="dynamic-form">
                                <fieldset disabled={this.state.canEdit}>


                                    <div className={cardClassName, "col-md-8"} style={{ padding: "50px", borderStyle: "solid", borderColor: "#a1c9c9", borderRadius: "7px", marginLeft: "auto", marginRight: "auto" }} >
                                        <div className="col-md-12">
                                            {this.renderHeader()}
                                            <div className="form-group">
                                                <label htmlFor="addressLine1" className={this.getLabelColClassName(), "font-weight-bold"}>Equipment name</label>
                                                <Text disabled field="name" id="equipmentName" className="form-control col" onInput={(e) => this.validateLength(e, 150)} />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="addressLine1" className={this.getLabelColClassName(), "font-weight-bold"}>Site</label>
                                                <div className={this.getValueColClassName()}>
                                                    <NextServiceSiteSelector field="address" />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="equipmentType" className={this.getLabelColClassName(), "font-weight-bold"}>Type</label>
                                                <div className={this.getValueColClassName()}>
                                            <EquipmentTypeSelector field="equipmentType" />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                            <label htmlFor="makeModel" className={this.getLabelColClassName(), "font-weight-bold"}>Make/Model</label>
                                        <div className={this.getValueColClassName()}>
                                                <EquipmentMakeModelSelector  field="makeModel" equipmenttype={this.state.submittedValues.equipmentType} />
                                        </div>
                                    </div>
                                        </div>
                                    </div>
                                    <br/>

                                    <div className="col-md-8 d-flex justify-content-center" style={{ marginLeft: "auto", marginRight: "auto" }}>
                                    <div className="col-6">
                                        {this.renderFinishEditingButton()}
                                    </div>
                                    <div className="col-6">

                                        {this.renderSaveButton()}
                                    </div>
                                </div>
                                </fieldset>
                            </form>
                )
                    }}
                </Form>
            </div >
        );
    }

}